export default __webpack_public_path__ + "static/media/opera.e6bb8753.png";